import { HubsRestartTimeProps } from "components/hubs/HubRestartDialog";

export function isHubRestarting(hubId: string, allOnline?: boolean, mainAppOnline?: boolean) {
  const restartTimesStored = localStorage.getItem("hubsRestartTime");

  if (restartTimesStored === null) return false;

  const parsedRestartTimesStored = JSON.parse(restartTimesStored);

  if (allOnline && mainAppOnline) {
    removeHubFromRestart(hubId, parsedRestartTimesStored);
    return false;
  }

  const currentHubRestartTime = parsedRestartTimesStored.filter((elem: HubsRestartTimeProps) => elem.id === hubId);

  if (currentHubRestartTime.length > 0) {
    if (currentHubRestartTime[0].until > Date.now()) {
      return true;
    }
    removeHubFromRestart(hubId, parsedRestartTimesStored);
    return false;
  }
  return false;
}

export function removeHubFromRestart(hubId: string, restartTimesStored: HubsRestartTimeProps[]) {
  const filteredRestartTimesStored = restartTimesStored.filter((elem: HubsRestartTimeProps) => elem.id !== hubId);

  if (filteredRestartTimesStored.length === 0) localStorage.removeItem("hubsRestartTime");
  else localStorage.setItem("hubsRestartTime", JSON.stringify(filteredRestartTimesStored));
}
